__turbopack_context__.v({
  "popoverContent": "Popover-module__IbiU1W__popoverContent",
});
